import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {VerifyPinRequest} from '../../model/local-api/verify-pin-request';
import {VerifyPinReponse} from '../../model/local-api/verify-pin-reponse';
import {GetRemainingAttemptsRequest} from '../../model/local-api/get-remaining-attempts-request';
import {GetRemainingAttemptsResponse} from '../../model/local-api/get-remaining-attempts-response';
import {GetSuspensionExpirationResponse} from '../../model/local-api/get-suspension-expiration-response';
import {GetSuspensionExpirationRequest} from '../../model/local-api/get-suspension-expiration-request';

@Injectable()
export class LocalApiService {

  static BOX_PROXY_URL = 'http://localhost:10414';
  private _STB_WEBSOCKET_URL = 'ws://localhost:10016/ui/subscriptionChanged';

  constructor(private httpClient: HttpClient) {
  }

  get STB_WEBSOCKET_URL(): string {
    return this._STB_WEBSOCKET_URL;
  }

  public getBoxLanguage(): Observable<Object> {
    return this.httpClient.get(LocalApiService.BOX_PROXY_URL + '/settings/getSetting/profile.osdLang');
  }

  public verifyPin(pin: string): Observable<VerifyPinReponse> {
    const body: VerifyPinRequest = {'pin': pin, 'pinType': 'master'} as VerifyPinRequest;
    return this.httpClient.post<VerifyPinReponse>(LocalApiService.BOX_PROXY_URL + '/auth/verifyPin', body);
  }

  public getRemainingAttempts(): Observable<GetRemainingAttemptsResponse> {
    const body: GetRemainingAttemptsRequest = {'pinType': 'master'} as GetRemainingAttemptsRequest;
    return this.httpClient.put<GetRemainingAttemptsResponse>(LocalApiService.BOX_PROXY_URL + '/auth/getRemainingAttempts', body);
  }

  public getSuspensionExpiration(): Observable<GetSuspensionExpirationResponse> {
    const body: GetSuspensionExpirationRequest = {'pinType': 'master'} as GetSuspensionExpirationRequest;
    return this.httpClient.put<GetSuspensionExpirationResponse>(LocalApiService.BOX_PROXY_URL + '/auth/getSuspensionExpiration', body);
  }

  public getBoxCpeId(): Observable<any> {
    const httpOptions = {
      withCredentials: false,
      headers: new HttpHeaders({
        'accept': 'application/json',
        'Content-Type': 'application/json'
      })
    };
    return this.httpClient.get(LocalApiService.BOX_PROXY_URL + '/configuration/getConfig/cpe.id', httpOptions);
  }

}
